export function hasDisclaimerAcceptance(user) {
  return Boolean(user?.disclaimer?.accepted)
}
